<template>
  <div class="subscriptions-widget">
    <date-widget
        v-model="year"
        style="margin-bottom: 5px"
        class="form-control input-sm"
        :parameters="{viewMode: 'years', widgetParent: '.subscriptions-widget'}"
        format="YYYY"
    ></date-widget>

    <loading-spinner v-if="loading" style="margin: 22px 0"></loading-spinner>

    <div v-else class="subscriptions-widget--scrollable">
      <table class="table table-condensed table-striped">
        <thead>
        <tr>
          <th class="col-xs-4 text-center">
            <input type="checkbox" v-model="selectAll">
          </th>

          <th class="col-xs-10">
            Publication
          </th>

          <th class="col-xs-10">
            Publish Date
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="publication in publications">
          <td class="col-xs-4 text-center">
            <input
                type="checkbox"
                :value="publication.value"
                :checked="isSelected(publication)"
                :disabled="isPublished(publication)"
                @click.stop="toggle(publication)"
            >
          </td>

          <td class="col-xs-10">
            {{ publication.attributes.name }}
          </td>

          <td class="col-xs-10">
            {{ publication.attributes.publish_at | date }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style>
.subscriptions-widget {
  border: 1px solid #ccc;
  padding: 5px;
}

.subscriptions-widget table {
  margin-bottom: 0
}

.subscriptions-widget--scrollable {
  max-height: 200px;
  overflow-y: scroll;
}
</style>

<script>
import http from '@/http'
import moment from 'moment'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {DateWidget, LoadingSpinner},

  props: {
    'value': {},
    'publicationBasedChannelId': {}
  },

  data() {
    return {
      selectAll: false,
      loading: true,
      publications: [],
      year: moment().format('YYYY-MM-DD'),
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    publicationBasedChannelId() {
      this.load()
    },

    year() {
      this.load()
    },

    selectAll(value) {
      if (value) {
        return this.$emit('input', this.publications
            .filter(publication => moment().isBefore(publication.attributes.publish_at))
            .map(publication => ({id: publication.id}))
        )
      }

      this.$emit('input', [])
    }
  },

  computed: {
    valueIds() {
      return this.value.map(publication => publication.id)
    }
  },

  methods: {
    load() {
      this.$emit('input', [])

      http.getList('/api/v2/publications', {
        'filter[publication_channel_id]': this.publicationBasedChannelId,
        'filter[publish_from]': moment(this.year).startOf('year').format('YYYY-MM-DD'),
        'filter[publish_to]': moment(this.year).endOf('year').format('YYYY-MM-DD'),
      }).then(publications => {
        this.publications = publications

        this.loading = false
      })
    },

    isSelected(publication) {
      return this.valueIds.indexOf(publication.id) > -1
    },

    isPublished(publication) {
      return moment().isAfter(publication.attributes.publish_at)
    },

    toggle(publication) {
      let newValue = this.value

      if (this.isSelected(publication)) {
        newValue.splice(this.valueIds.indexOf(publication.id), 1)
      } else {
        newValue.push({id: publication.id})
      }

      this.$emit('input', newValue)
    },

    removeAll() {
      this.$emit('input', [])
    },

    addAll() {
      this.$emit('input', this.publications.map(publication => ({id: publication.id})))
    }
  }
}
</script>
